export const PT = {
  preparing_zip: "Preparando o zip…",
  compressing: "Compactando…",
  info_icon: "Uma vez marcado como concluído, nenhum membro adicional pode ingressar ou ser adicionado, e todos os grupos de chat serão desativados. Observe que o projeto, junto com todos os grupos de chat e dados, permanecerá acessível em um estado desativado.",
  mark_is_done: "Tem certeza de que deseja marcar o projeto como concluído? Uma vez marcado, nenhum membro adicional pode ingressar ou ser adicionado, e todos os grupos de chat serão desativados. Observe que o projeto, junto com todos os grupos de chat e dados, permanecerá acessível em um estado desativado.",
  mark_not_done: "Tem certeza de que deseja reabrir o projeto? Uma vez marcado como aberto, membros adicionais podem ingressar ou ser adicionados, e todos os grupos de chat serão reativados.",
  mark_as_completed: "Marcar projeto como concluído",
  room_completed: "Projeto concluído",
  room_members: "Membros do projeto",
  deactivated_rooms: "Projetos desativados",
  deactivated_chats: "Chats desativados",
  completed_rooms: "Projetos concluídos",
  request_to_join_a_room: 'Solicitar ingressar no projeto',
  wants_to_rejoin_room: 'Username quer voltar a ingressar no projeto Roomname.',
  invited_you_to_join_room: 'Username convidou você para ingressar no projeto Roomname.',
  restart: "Reiniciar",
  update_text: "Uma nova atualização está disponível. Clique em reiniciar para instalar a atualização.",
  update_availble: "Atualização disponível",
  Loading: "Carregando...",
  logout: "Sair",
  back: 'Voltar',
  company_list: "Lista de empresas",
  followers: "Seguidores",
  followings: "Seguindo",
  article: "Artigo",
  companies: "Empresas",
  one_to_one_chat: " Chat um a um",
  profile: "Perfil",
  company: "Empresa",
  company_selection: "Seleção de empresa",
  home: "Início",
  contact: "Contato ",
  add_company: "Adicionar empresa ",
  add_project: "Adicionar projeto ",
  capacities: "Capacidades ",
  work_area: "Área de trabalho",
  company_services: "Serviços da empresa",
  website: "Site",
  search_contacts: "Buscar contatos",
  add_or_join_a_company: "Adicionar ou ingressar em uma empresa",
  follow: "Seguir",
  following: "Seguindo",
  like: "Curtir",
  company_contacts: "Contato da empresa",
  leave_the_company: "Deixar a empresa",
  news: "Notícias",
  earlier: "Anterior",
  action: "Ação",
  another_action: "Outra ação",
  something_else: "Outra coisa",
  search: "Buscar",
  search_rooms: "Buscar projetos",
  search_articles: "Buscar artigos",
  contacts: "Contatos",
  suggestions: "Sugestões",
  project_list: "Lista de projetos",
  search_results: "Resultados da busca",
  add_or_join_project: "Adicionar ou ingressar no projeto",
  details: "Detalhes",
  your_position_within_company:
    "Por favor, escolha sua posição dentro da empresa.",
  close_modal: "Fechar",
  map: "Mapa",
  or: "Ou",
  name: "Nome*",
  street: "Rua*",
  house_number: "Número da casa",
  postal_code: "Código postal",
  city: "Cidade*",
  opened_by: "Aberto por:",
  project_No: "Número do projeto: ",
  building_type: "Tipo de construção*",
  building_types: "Tipo de construção",
  add_join: "Adicionar/Ingressar",
  mandatory_fiels: "*campos obrigatórios",
  invalid_fiels: "Este campo é obrigatório",
  add_or_join_company: "Adicionar ou ingressar na empresa",
  name_of_the_company: "Nome da empresa",
  edit_company_details: "Editar detalhes da empresa",
  branch_of_the_building_industry: "Ramo da indústria da construção",
  corporate_form: "Forma corporativa",
  position_within_company: "Posição dentro da empresa",
  request_confirmation: "Solicitações de projeto pendentes",
  company_e_mail: "E-mail da empresa",
  type_of_filter: "Digite para filtrar...",
  setting: "Configuração",
  dashboard: "Painel",
  settings: "Configurações",
  views: "Visualizações",
  times_seen: "vezes visto",
  see_more: "...mais",
  see_less: "...menos",
  in_search: "na busca",
  reset_password: "Redefinir senha",
  submit: "Enviar",
  password: "Senha",
  email: "E-mail",
  confirm_password: "Confirmar senha",
  reset_email: "Redefinir e-mail",
  update: "Atualizar",
  new_email: "Novo e-mail",
  kjuup_message: "Mensagem Kjuup",
  delete_profile: "Excluir perfil?",
  my_position: "Minha posição:",
  add: "adicionar",
  owner_company_admin: "Administrador da empresa :",
  owner_company_admin_new: "Administrador da empresa",
  mutual_contact: "contato mútuo",
  mutual_contacts: "contatos mútuos",
  co_owner: "Co-proprietário",
  managing_director: "Diretor geral",
  associate: "Associado",
  secretary: "Secretário",
  employee: "Funcionário",
  project_manage: "Gerente de projeto",
  auto_chat_translation: "Tradução automática de chat",
  translate_room_group_names: "Traduzir nomes dos grupos de chat",
  translate_room_group_names_info: "Quando ativado, os nomes dos grupos de chat são traduzidos automaticamente para o idioma da interface.",
  default_view_email: "Vista padrão: E-Mail",
  default_view_email_info: "Quando ativado, a aba de E-Mail será aberta por padrão em vez de Mensagens ao abrir o aplicativo.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Idioma",
  english: "Inglês",
  german: "Alemão",
  french: "Francês",
  italian: "Italiano",
  change_language: "Alterar idioma",
  my_companies: "Minhas empresas",
  employees: "Funcionários",
  invite_with_a: "Convidar para Kjuup",
  add_member: "Adicionar membro",
  add_user: "Adicionar usuário",
  send_location: "Enviar localização",
  assign_admin_rights: "Ajustar direito de administrador",
  deactivate_company: "Desativar empresa",
  remove_employees: "Remover funcionários",
  remove_members: "Remover membros",
  no_user_found: "Nenhum usuário encontrado!",
  approve: "Aprovar!",
  deselect_all: "Desmarcar tudo",
  select_all: "Selecionar tudo",
  translation_on_building_projects: "Tradução em projetos",
  reported_capacities: "Serviços relatados",
  up_to_50m_exact: "Até 50m exato",
  company_details_service: "Serviços da empresa",
  company_contact: "Contato da empresa",
  invite_with_link: "Convidar para Kjuup",
  share_link: "Compartilhar link",
  share_company_link: "Compartilhar link",
  qr_code: "Código QR",
  copy_link: "Copiar link",
  cancel_link: "Cancelar link",
  who_has_confirmed_services: "Quem confirmou seus serviços?",
  projectss: "Projetos",
  add_services: "Adicionar serviços",
  services: "Serviços",
  save_text: "Salvar",
  share_on: "Compartilhar em:",
  articlen: "Artigo",
  invite_user_to_confirm_service:
    "Convide usuários para confirmar serviços à empresa.",
  link_copied: "Link copiado!",
  email_copied: "E-mail copiado!",
  personal_article: "Artigo pessoal",
  company_article: "Artigo da empresa",
  characters_remaining: "Caracteres restantes",
  optional_information: "Informação opcional",
  project: "Projeto",
  projects: "Projetos...",
  abort: "Descartar",
  preview: "Visualizar",
  post: "Publicar",
  of: "de",
  remove: "Remover",
  free_capacity: "Portal de empregos",
  current_status_overview: "Visão geral do status atual",
  report_capacities: "Relatar serviços",
  report_text: "Relatar",
  search_capacities: "Encontrar contratados",
  add_project_user: "Adicionar usuário do projeto",
  media: "Mídia",
  links: "Links",
  docs: "Documentos",
  featured_products: "Produtos em destaque...",
  title: "Título",
  text: "Texto",
  feed_details: "Detalhes do feed",
  add_employee: "Adicionar funcionário",
  latest: "Mais recente",
  my_projects: "Meus projetos",
  cancel: "Cancelar",
  continue: "Continuar",
  role_in_the_building_industry: "Papel na indústria da construção",
  als: "como",
  join: "ingressar",
  find: "Encontrar",
  request_to_join_a_company: "Solicitar ingressar na empresa",
  wants_to_join_the_company: "quer ingressar na empresa",
  filter_by: "Filtrar por",
  ok: "Ok",
  close: "Fechar",
  weekly_statistics: "Estatísticas semanais",
  is_following_you: "está seguindo você.",
  as: "como",
  has_joined_the: "ingressou na empresa",
  has_looked_at_your_profile: "visualizou seu perfil.",
  time: "Hora",
  in_searches_in_past_week: "em buscas na semana passada.",
  has_liked_your_article: "curtiu seu artigo.",
  has_published_a_new_article: "publicou um novo artigo.",
  you: "Você",
  all_views: "Todas as visualizações",
  all_profile_views: "Todas as visualizações do perfil",
  mutual_company: "empresa mútua",
  artical_text: "Escrever artigo...",
  you_have_appeared: "Você apareceu",
  your_request_at_the_company: "Sua solicitação na empresa",
  times_you_have_appeared_in_searches: "vezes que você apareceu em buscas",
  appear_more_often_in_searches: "Aparecer mais frequentemente em buscas",
  you_have_been_found: "Você foi encontrado",
  improve_profile: "Melhorar perfil",
  choose_existing_contact_for_single_chat:
    "Escolher contato existente para chat individual:",
  in_order_to_add_new_contacts:
    "Para adicionar novos contatos, busque novos contatos na página de perfil.",
  times_in_searches_in_the_last_week:
    "vezes em buscas na última semana. Atualize seu perfil e adicione mais detalhes para ser encontrado mais facilmente.",
  has_been_confirmed: "foi confirmado.",
  have_joined_the: "ingressaram no  ",
  building_project: " projeto de construção.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Selecione a empresa que você representará. Isso será exibido para outros participantes.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Selecione a empresa que você representará. Isso será exibido para outros participantes.",
  select_internal_section: "Por favor, selecione seção interna",
  select_profile_image: "Selecionar imagem de perfil",
  share_user: "Compartilhar usuário",
  contact_sender_message:
    "Compartilhe este link para convidar um não membro do Kjuup para o Kjuup. Este link pode ser usado por várias pessoas para se registrar.",
  project_sender_message:
    "Compartilhe este link para convidar um não membro do Kjuup para o projeto nome do projeto. Este link pode ser usado por várias pessoas para se registrar e ingressar no projeto nome do projeto no Kjuup.",
  company_sender_message:
    "Compartilhe este link para convidar um não membro do Kjuup para a empresa nome da empresa. Este link pode ser usado por várias pessoas para se registrar e ingressar na empresa no Kjuup.",
  contact_receivers_message:
    "Link de convite para ingressar no Kjuup. Por favor, clique no link para se registrar no kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Caso esteja instalando o Kjuup via Apple App Store, você deve clicar neste link após o download bem-sucedido, para poder se registrar.",
  project_receivers_message:
    "Link de convite para ingressar no projeto nome do projeto no Kjuup. Por favor, clique no link para se registrar no Kjuup e ingressar no projeto nome do projeto.",
  company_receivers_message:
    "Link de convite para a empresa nome da empresa no Kjuup. Por favor, clique no link para se registrar no Kjuup e ingressar na empresa nome da empresa.",
  sign_in: "Entrar",
  enter_your_email_add: "Digite seu endereço de e-mail",
  forgot_password: "Esqueceu a senha?",
  dont_have_account: "Não tem uma conta?",
  register: "Registrar",
  get_app: "Obter o aplicativo",
  registration: "Registro",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arquiteto",
  prof: "Prof.",
  first_name: "Nome",
  last_name: "Sobrenome",
  have_an_account: "Tem uma conta?",
  when_register_you_agree: "Ao se registrar, você concorda com nossos",
  term_of_use: "termos de uso",
  to: "a.",
  in_our: "Em nossa",
  data_policy: "políticas de dados",
  they_find_out: "eles descobrem,",
  we_provide_store_data: "como coletamos, processamos e armazenamos informações.",
  leaving_company_text:
    "Você realmente deseja deixar a empresa? Ao deixar a empresa, você também deixa todos os projetos e grupos de chat associados. Você pode ingressar novamente nesses projetos com outra empresa a qualquer momento.",
  delete_profile_text:
    "Você realmente deseja excluir seu perfil? Quando você excluir seu perfil, todas as conexões com empresas, projetos e chats serão removidas. Você pode criar um novo perfil a qualquer momento.",
  confirm: "Confirmar",
  reject: "Rejeitar",
  requet_to_leave: "Solicitar sair",
  choose: "Escolher",
  your_add_member: "Adicionar membro",
  if_you: "caso você",
  can_not_find: "não consiga encontrar seu contato aqui.",
  please_wait: "Por favor, aguarde..",
  imprint_gtc: "Impresso/Termos e condições",
  register_confirm_popup: "Verifique o seu e-mail Kjuup antes de iniciar sessão. Enviámos um link de confirmação. Se não o vir, verifique também a pasta de spam.",
  PENDING_GROUP_USER:
    "receberá mensagens apenas após a confirmação do convite para o projeto. Uma mensagem adicional aparecerá assim que o convite para o projeto for confirmado.",
  PENDING: "Confirmação de convite para o projeto pendente",
  denied_group_chat: " negou o convite para o projeto e deixou este grupo.",
  // joined_group_chat: " ingressou na sala e neste grupo.",
  joined_group_chat: " ingressou neste grupo",
  you_joined_group_chat: "Você ingressou neste grupo.",
  Others: "Outros",
  LEFT_GROUP: "deixou este grupo de chat.",
  YOU_LEFT_GROUP: "deixaram este grupo de chat.",
  days: "dias",
  day: "dia",
  hour: "hora",
  hide_project: "Ocultar projeto",
  hide_project_popup_text:
    "Se você ocultar projetos, eles não podem ser encontrados no Kjuup. Apenas membros do projeto podem convidar novos usuários para o projeto.",
  branch: "Ramo",
  photo_video_media_lib: "Biblioteca de mídia - Foto e vídeo",
  document: "Documento",
  location_meeting: "Localização / Reunião",
  all_member_of_project: "Todos os membros do projeto",
  pending_request: "Solicitações de projeto pendentes",
  no_pending_request: "Nenhuma solicitação pendente encontrada!",
  news_feed: "Feed de notícias",
  user_info: "Informações do grupo",
  leave_project: "Deixar projeto",
  media_link_docs: "Arquivos",
  search_chat: "Buscar chat",
  export_chat_group: "Exportar dados do grupo de chat do último mês",
  request_complete_chat_history: "Solicitar histórico completo de chat",
  leave_chat_group: "Deixar grupo de chat",
  add_user_project: "Adicionar usuário",
  me: "Eu",
  max_open_one_to_one:
    "Atualmente, máx. 2 chats um a um podem ser abertos em paralelo na seção inferior e superior. No total, máx. 4 chats um a um são possíveis.",
  are_you_sure_you_want_leave_chat:
    "Tem certeza de que deseja deixar este grupo de chat?",
  create_group: "Criar grupo",
  adding_members: "Adicionando membros...",
  creating_the_chat: "Criando o chat...",
  finishing_setup: "Finalizando...",
  group_name: "Nome do grupo",
  by: "Por:",
  mandetory: "*obrigatório",
  delteed: "excluiu seu perfil e deixou o chat em grupo.",
  deleted_direct: "excluiu seu perfil e deixou o chat.",
  unhidden_message:
    "Se você mostrar projetos, eles podem ser encontrados por todos os membros do Kjuup.",
  account_deleted: "A conta foi excluída.",
  refuse_company: "Tem certeza de que deseja recusar o convite da empresa?",
  follow_additional: "Seguir usuários adicionais",
  f_add:
    "Siga usuários adicionais do Kjuup para torná-los disponíveis para mensagens diretas.",
  c_inv: "Convite(s) de empresa",
  invited_o_Company: "Você foi convidado a ingressar na empresa",
  refuse_companyX: "Tem certeza de que deseja recusar a solicitação da empresa?",
  a_Da: "Conta desativada.",
  has_deactivated: "desativou seu perfil.",
  reactive: "reativou seu perfil.",
  juup_note: "*Registro com nome de usuário disponível apenas para membros do Kjuup+",
  username: "Nome de usuário*",
  email_username: "E-mail/Nome de usuário*",
  sPinText:
    "Por favor, forneça um PIN de segurança de 6 dígitos. Este PIN será necessário caso você esqueça sua senha e é obrigatório para confirmar sua conta.",
  DeleteKjuupPlusText:
    "Você realmente deseja excluir seu perfil? Quando você excluir seu perfil, todas as conexões com empresas, projetos e chats serão removidas.\n\nDentro de 48 horas após a exclusão da conta, você pode reativar sua conta fazendo login com nome de usuário, senha e PIN.",
  reactive_text:
    "Sua conta foi excluída. Por favor, clique em Reativar para reativar sua conta.",
  rac: "Reativar",
  ac_ss: "Conta reativada com sucesso.",
  not_valid_pin: "PIN inválido",
  only_for_kjuup:
    "*Redefinição de senha via nome de usuário e PIN disponível apenas para membros do Kjuup+.",
  resetPIN: "Redefinir PIN",
  enter_current_pin: "Por favor, digite seu PIN atual",
  enter_new: "Digite novo PIN",
  pin_to_confirm: "Por favor, forneça o PIN para confirmar.",
  change_username: "Redefinir nome de usuário",
  pp_not_match: "A senha e a confirmação de senha não coincidem",
  reactive_itself: "Você reativou seu perfil.",
  has_deactivated_itself: "Você desativou seu perfil.",
  more_than_two:
    "Atualmente, mensagens diretas só podem ser feitas com 2 usuários em paralelo.",
  Chats: "Mensagens diretas",
  only_in_mobileL:
    "Vídeos nativos atualmente só podem ser enviados e publicados via aplicativo móvel. Por favor, use links de vídeo do Youtube e Vimeo.",
  register_pin_text:
    "Por favor, escolha seu PIN pessoal de 6 dígitos. Este PIN será necessário para habilitar funcionalidades de redefinição de conta.",
  internal_project: "Interno",
  external_projects: "Externo",
  in_deacticted: "A seção interna está desativada.",
  create_article: "Criar artigo",
  new_article_selection: "Criar artigo para feed de notícias externo",
  new_article_selection_internal: "Criar artigo interno",
  active_trans_title: "Ativar tradução automática?",
  active_trans: "Quando ativada, todas as mensagens de chat recebidas serão traduzidas para o idioma do aplicativo selecionado.",
  disable_trans: "Você realmente deseja desativar a tradução automática?",
  allow_access_chat: "Mostrar histórico completo de chat",
  toggle_chat_history_on:
    "Você realmente deseja que o usuário veja o histórico completo de chat?",
  toggle_chat_history_off:
    "Você realmente deseja que o usuário veja apenas o histórico de chat a partir do ponto de ingressar no chat?",
  check_selected_settings:
    "Por favor, verifique as configurações do histórico de chat para todos os usuários selecionados!",
  chat_from_start_have:
    "Você ingressou neste grupo. O histórico de chat foi compartilhado.",
  chat_from_start_has:
    "ingressou neste grupo. O histórico de chat foi compartilhado.",
  Address: "Endereço",
  read_by: "Lido por",
  deliver_to: "Entregue para",
  remaining: "restante",
  message_info: "Informações da mensagem",
  request_to_join_only: "Solicitar ingressar",
  unfollow: "Deixar de seguir",
  company_username: "Nome de usuário",
  month: [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ],
  remove_my_admin_right: "Remover meus direitos de administrador",
  makeEmp: "Você realmente deseja remover os direitos de administrador da empresa do usuário?",
  remove_my_self:
    "Você realmente deseja remover os direitos de administrador da empresa da sua conta?",
  makeAdmin: "Você realmente deseja dar ao usuário direitos de administrador da empresa?",
  remove_member: "Remover membro",
  remove_following_confirm: "Tem a certeza de que deseja remover {name} da lista de seguidos?",
  remove_follower_confirm: "Tem a certeza de que deseja remover {name} dos seus seguidores? Se o remover, não será informado/a.",
  do_you_really_want_to_remove:
    "Você realmente deseja remover o nome de usuário da empresa?",
  invite_all: "Convidar todos os membros da empresa",
  invite_all_members: "Convidar todos os membros",
  mems: "Todos os outros membros",
  dep_loc: "Departamento/Localização/Equipe",
  depAdmin: "Administrador de departamento",
  add_remove_admin: "Adicionar/Remover posição de administrador da empresa",
  add_remove_dep_admin: "Adicionar/Remover posição de administrador de departamento",
  remove_employees_dept: "Remover funcionários de",
  want_to_join_dep:
    "Nome de usuário quer ingressar no Departamento/Localização/Equipe depname da empresa companyname.",
  you_invited:
    "Você foi convidado a ingressar no Departamento/Localização/Equipe depname da empresa companyname.",
  dep_remove:
    "Você realmente deseja remover os direitos de administrador de departamento ou localização do usuário?",
  add_dep:
    "Você realmente deseja dar ao usuário direitos de administrador para o departamento ou localização?",
  my_self_dep_remove:
    "Você realmente deseja remover os direitos de administrador de departamento da sua conta?",
  member: "Membro",
  admin: "Administrador",
  remove_project_admin:
    "Você realmente deseja remover o membro do projeto?",
  remove_my_self_project: "Você realmente deseja remover os direitos de administrador?",
  remove_member_admin_right:
    "Você realmente deseja remover os direitos de administrador do usuário?",
  add_member_admin_right: "Você realmente deseja adicionar direitos de administrador ao usuário?",
  add_remove_Poss: "Adicionar/Remover posição de administrador",
  forward: "Encaminhar",
  edit: "Editar",
  only_kjuup_plus_can: "Apenas empresas Kjuup+ podem publicar artigos.",
  add_images: "Adicionar imagem(ns)",
  request_confirmation: 'Convites de projeto pendentes',
  Activity: "Atividade",
  latest_messages: "Mensagens mais recentes",
  hours: "horas",
  minute: "minutos",
  seconds: "segundos",
  days: "dias",
  yesterday: "ontem",
  last_week: "semana passada",
  next_week: "próxima semana",
  Last_month: "mês passado",
  All: "Tudo",
  register_plus: "Registro Plus",
  select_files: "Selecionar arquivos",
  monthsFullName: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  company_deploc_receivers_message:
    "Link de convite para o departamento da empresa nome da empresa no Kjuup. Por favor, clique no link para se registrar no Kjuup e ingressar na empresa nome da empresa.",
  no_news: "Nenhuma notícia disponível",
  reminder: "Lembrete",
  np_reminder: "Sem tarefas pendentes",
  move_to_reminder: "Mover para tarefa pendente",
  remove_reminder: "Você realmente deseja remover esta mensagem da lista de suas tarefas pendentes?",
  remove_all_reminder: "Remover todas as tarefas pendentes",
  remove_all_confirm: "Você realmente deseja remover todas as mensagens da lista de suas tarefas pendentes?",
  remove_from_reminder: "Remover do lembrete",
  prevent_email: "O e-mail não pode ser usado como nome de usuário.",
  allow_noti: "Por favor, permita notificações.",
  join_cap: "Ingressar",
  pass_minimum:
    "**A senha requer 12 caracteres incl. letra minúscula, maiúscula, número e caractere especial.",
  pass_error: "Por favor, verifique os requisitos de senha",
  people_that_like_article: "Pessoas que curtiram o artigo.",
  people_who_like_article: "Pessoas que curtiram seu artigo.",
  message_delete: "Esta mensagem foi excluída.",
  message_edited: "editado",
  edit_message: "Editar mensagem",
  edit_window_expired: "As mensagens só podem ser editadas até 10 minutos após o envio.",
  message_edit_save: "Salvar",
  copy: "Copiar",
  bookmark: "Favorito",
  add_reaction: "Adicionar reação",
  delete_message: "Excluir mensagem",
  more_options: "Mais opções",
  info: "Info",
  link_invite: "Convidar via link",
  ll_nkk: "Convidar para Kjuup",
  selected: "Selecionado",
  is_active: "Ativo",
  inactive: "Inativo",
  last_online: "visto por último {{when}}",
  remove_user_l: "Remover",
  link_expire: "Cada link gerado será válido por 72 horas.",
  company_language: "Idioma da empresa",
  company_language_info:
    "A seleção de idioma será usada para todas as confirmações por e-mail relacionadas à empresa.",
  s_image: "imagem",
  m_image: "imagens",
  removeMsg: "Toque para remover",
  block: 'Bloquear',
  unblock: 'Desbloquear',
  blocks: 'Tem certeza de que deseja bloquear este usuário?',
  unblocks: 'Tem certeza de que deseja desbloquear este usuário?',
  bolcked_click_un_block:
    'Você bloqueou este contato. Clique aqui para remover o bloqueio.',
  you_have_unblocked: 'Você desbloqueou este contato.',
  you_have_blocked: 'Você bloqueou este contato.',
  unblock_to_send: 'Desbloquear usuário para enviar mensagem.',
  pilot_text: "IA especializada para tópicos de construção",
  startup_screen_label: "Ecrã inicial",
  startup_screen_info: "Escolha qual ecrã abre ao iniciar o Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Mensagens",
  startup_screen_saved: "Ecrã inicial atualizado",
email_on: "Notificações por e-mail de chats",
  email_on_grp: "Notificação por e-mail",
  article_email_on: "Notificações por e-mail de artigos",
  article_email_info: "Se você habilitar notificações por e-mail para artigos internos, receberá um e-mail quando um novo artigo interno for publicado na sua empresa e departamento.",
  info_email_room: "Ative ou desative notificações por e-mail para este projeto. Esta opção está disponível apenas quando \"Notificações por e-mail de chats\" está habilitada através das configurações pessoais.",
  todo_notification_info: "Você será notificado sempre que uma nova tarefa for atribuída a você.",
  info_val: "Você receberá um e-mail se uma nova mensagem de chat não for lida em pouco tempo. Você pode desativar isso para projetos ou chats específicos nas configurações deles ou nas informações do grupo de chat.",
  email_groups: "Ative ou desative notificações por e-mail para este chat. Esta opção está disponível apenas quando \"Notificações por e-mail de chats\" está habilitada através das configurações pessoais e do projeto.",
  add_update_email: "Adicionar/Atualizar e-mail",
  text_to_verifiy: "A opção \"Notificações por e-mail de chats\" só pode ser habilitada se você tiver um endereço de e-mail verificado em arquivo.",
  stored_email: "E-mail armazenado: ",
  verify_email: "Confirmação pendente!",
  join_call:"Ingressar",
  call_is_started:"Chamada iniciada",
  start_chat:"Iniciar chat direto?",
  project_rooms:"Projetos",
  download_selected:"Baixar",
  add_employee_confirm: 'Tem certeza de que deseja adicionar este usuário à empresa?',
  invalid_deeplink: "URL de link profundo inválida. Parâmetros obrigatórios ausentes.",
  deeplink_error: "Não foi possível processar o link profundo. Por favor, tente novamente mais tarde.",
  // Reply functionality translations
  reply: "Responder",
  reply_enter: "Digite resposta...",
  reply_sent_successfully: "Resposta enviada com sucesso",
  reply_failed: "Falha ao enviar resposta",
  reply_failed_generic: "Falha ao enviar resposta. Por favor, tente novamente.",
  replying_to_message: "Respondendo à mensagem",
  cancel_reply: "Cancelar resposta",
  voice_message: "Mensagem de voz",
  send: "Enviar",
  cancel: "Cancelar",
  type_your_reply: "Digite sua resposta...",
  
  // Auto-suggestion translations
  suggested_replies: "Respostas sugeridas",
  suggestions_error: "Falha ao carregar sugestões",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Imagem — Clique para carregar",
  lazy_media_audio: "Mensagem de voz — Clique para carregar",
  lazy_media_doc: "Documento — Clique para carregar",
  lazy_media_video: "Vídeo — Clique para carregar",
  suggestion_loading_message: "Aguarde um momento. Seu texto está sendo preparado individualmente para você.",
  loading_chat_message: "Carregando chat...",
  
  // Manual ToDo translations
  extracting_message: "Extraindo mensagem...",
  create_todo: "Criar tarefa pendente",
  create_todo_confirmation: "Deseja criar uma tarefa pendente a partir desta mensagem?",
  select_project_required: "Por favor, selecione um projeto/grupo",
  only_assigned_can_change_status: "Apenas usuários atribuídos podem alterar o status",
  todo_summary: "Resumo",
  todo_summary_placeholder: "Digite resumo da tarefa pendente...",
  todo_date: "Data",
  todo_time: "Hora",
  todo_date_hint: "Deixe vazio para usar a data/hora da mensagem original",
  todo_created_success: "Tarefa pendente criada com sucesso",
  todo_creation_failed: "Falha ao criar tarefa pendente",
  create: "Criar",
  
  image: "imagem",
  images: "imagens",
  remove_all_images: "Remover todas as imagens",
  remove_image: "Remover imagem",
  remove_document: "Remover documento",
  remove_recording: "Remover gravação",
  play_recording: "Reproduzir gravação",
  upload_image: "Enviar imagem",
  upload_document: "Enviar documento",
  record_audio: "Gravar áudio",
  stop_recording: "Parar gravação",
  stop_recording_text: "Parar gravação",
  please_remove_current_attachment: "Por favor, remova o anexo atual para",
  please_upload_image_file: "Por favor, envie um arquivo de imagem válido",
  please_upload_valid_document: "Por favor, envie um arquivo de documento válido",
  searching_messages: "Buscando mensagens...",
  loading_more: "Carregando mais...",
  loading_more_users: "Carregando mais usuários...",
  load_more_users: "Carregar mais usuários",
  no_more_users_to_load: "Não há mais usuários para carregar",
  no_messages_found: "Nenhuma mensagem encontrada",
  try_different_keyword: "Tente uma palavra-chave diferente ou verifique sua ortografia.",
  search_messages: "Pesquisar mensagens, grupos de chat, projetos e utilizadores...",
  todo: "Tarefa pendente",
  np_todo: "Sem tarefas pendentes",
  move_to_todo: "Salvar como tarefa pendente",
  remove_todo: "Você realmente deseja remover a tarefa pendente?",
  remove_all_todo: "Remover todas as tarefas pendentes",
  remove_all_todo_confirm: "Você realmente deseja remover todas as tarefas pendentes?",
  add_to_todo: "Adicionar a tarefa pendente",
  remove_from_todo: "Remover de tarefa pendente",
  confirm: "Confirmar",
  ok: "Ok",
  read_more: "Ler mais",
  show_less: "Mostrar menos",
  show_more: "Mostrar mais",
  audio: "Áudio",
  video: "Vídeo",
  // Notification Settings
  notification_schedule: "Agendamento de notificações",
  notification_schedule_desc: "Você receberá notificações push e por e-mail apenas nas horas que escolher. Fora desses horários, elas serão pausadas.",
  learn_more: "Saiba mais",
  allow_notifications: "Permitir notificações:",
  every_day: "Todos os dias",
  weekdays: "Dias úteis (segunda a sexta)",
  custom: "Personalizado",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
  to: "a",
  notification_settings: "Notificações",
  notification_settings_saved: "Configurações de notificações salvas com sucesso",
  notification_settings_error: "Falha ao salvar configurações de notificações",
  unavailability_note: "Nota de ausência",
  unavailability_description: "Defina uma nota de ausência. Enquanto ativa, a nota é exibida para outros em todos os seus chats e as notificações são pausadas.",
  unavailability_start_date: "Data de início",
  unavailability_end_date: "Data de fim",
  unavailability_message: "Mensagem",
  unavailability_message_hint: "Use {endDate} como marcador para a sua data de regresso.",
  unavailability_replacement: "Contacto de substituição",
  unavailability_replacement_placeholder: "Inserir ID de utilizador para pedidos urgentes",
  unavailability_replacement_current: "Substituto atual",
  unavailability_replacement_hint: "Se definido, um link para contactar esta pessoa para assuntos urgentes será mostrado na sua nota de ausência.",
  unavailability_replacement_none: "Sem substituição (opcional)",
  unavailability_contact_urgent: "Para pedidos urgentes contacte",
  unavailability_default_message: "De momento não estou no escritório e não tenho acesso ao Kjuup. Estarei novamente disponível a partir de {endDate} e entrarei em contacto consigo nessa altura.",
  unavailability_save: "Guardar",
  unavailability_deactivate: "Desativar",
  unavailability_active_until: "Ativo até",
  unavailability_saved: "Nota de ausência guardada",
  unavailability_save_error: "Erro ao guardar a nota de ausência",
  unavailability_deactivated: "Nota de ausência desativada",
  unavailability_end_date_required: "A data de fim é obrigatória",
  start_time_before_end_time: "A hora de início deve ser antes da hora de término",
  loading: "Carregando",
  disabled: "Desabilitado",
  enable: "Habilitar",
  disable: "Desabilitar",
  forwarded: "Encaminhado",
  message_forwarded: "Mensagem encaminhada!",
  // Schedule Article
  schedule_article_post: "Agendar publicação de artigo",
  date: "Data",
  time: "Hora",
  scheduled_for_publication: "Agendado para publicação",
  article_will_be_published_on: "O artigo será publicado em:",
  reset_selection: "Redefinir seleção",
  continue: "Continuar",
  cancel: "Cancelar",
  // Member Selection
  error_loading_members: "Erro ao carregar membros",
  please_fill_all_fields: "Por favor, preencha todos os campos",
  invalid_email: "Endereço de e-mail inválido",
  member_added_successfully: "Membro adicionado com sucesso",
  error_onboarding_user: "Erro ao adicionar usuário",
  error_creating_chat: "Erro ao criar chat",
  error_creating_group: "Erro ao criar grupo",
  new_group: "Novo grupo",
  please_select_or_enter_group_name: "Por favor, selecione um grupo ou digite um nome de grupo",
  please_select_or_enter_room_name: "Por favor, selecione um projeto ou digite um nome de projeto",
  error_creating_room: "Erro ao criar projeto",
  error_opening_chat: "Erro ao abrir chat",
  privacy_modal_text: "Selecione \"Privado\" apenas se o chat não contiver conteúdo profissional relevante para o gerente de projeto.",
  not_private: "Não privado",
  private: "Privado",
  error_loading_groups: "Erro ao carregar grupos",
  automatic_chat_export: "Exportação automática de chat",
  automatic_chat_export_info: "Após a ativação, o histórico de chat será enviado automaticamente para o endereço de e-mail especificado a cada mês.",
  automatic_chat_export_no_email: "Para ativar a exportação automática de chat, primeiro você precisa adicionar um endereço de e-mail. Você pode adicionar seu endereço de e-mail nas configurações pessoais.",
  enter_email: "Digite e-mail",
  update: "Atualizar",
  confirm: "Confirmar",
  export_to_email: "A exportação vai para o seguinte e-mail.",
  start_chat_button:"Nova mensagem",
  matching_existing_chats: "Chats existentes correspondentes",
  subject: "Assunto",
  add_subject: "Adicionar assunto",
  chat_subject: "Assunto do chat:",
  set_project_room: "Definir projeto",
  matching_existing_project_rooms: "Projetos existentes correspondentes",
  name_project_room: "Nomear projeto",
  professional_or_private: "Profissional ou privado",
  professional: "Profissional",
  privacy_modal_text_updated: "Selecione \"Privado\" apenas se o chat não contiver conteúdo profissional relevante para gerentes de projeto. Chats privados não são visíveis para gerentes de projeto.",
  create_internal_chat: "Chat externo ou interno?",
  internal_chat_description: "Apenas funcionários da sua empresa podem ser adicionados a chats internos.",
  yes: "Sim",
  no: "Não",
  chat_is_being_created: "O chat está sendo criado...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Deseja realmente descartar as alterações deste artigo?",
  please_enter_article_title: "Por favor, digite primeiro o título do artigo.",
  please_add_mandatory_fields: "Por favor, adicione todos os campos obrigatórios",
  product_label: "Produto:",
  no_companies_found: "Nenhuma empresa encontrada",
  visible_to_all_followers: "Visível para todos os membros Kjuup",
  only_visible_to_employees: "Apenas visível para funcionários",
  something_went_wrong: "Algo deu errado, por favor tente novamente",
  please_select_department: "Por favor, selecione departamento/localização",
  schedule: "Agendar",
  please_select_future_date_time: "Por favor, selecione uma data e hora futuras para agendar o artigo.",
  please_select_different_date_time: "Por favor, selecione uma data ou hora diferente para agendar o artigo.",
  please_select_later_time: "Por favor, selecione uma hora posterior à hora atual para hoje.",
  unpin_article: "Desafixar artigo",
  pin_article: "Fixar artigo",
  and: "e",
  others: "outros",
  at: "em",
  // Chat mute/unmute translations
  mute: "Silenciar",
  unmute: "Ativar som",
  chat_muted_successfully: "Chat silenciado com sucesso",
  chat_unmuted_successfully: "Som do chat ativado com sucesso",
  mute_chat_confirm: "Você realmente deseja silenciar este chat? Você não receberá mais notificações para novas mensagens.",
  unmute_chat_confirm: "Você realmente deseja ativar o som deste chat? Você voltará a receber notificações para novas mensagens.",
  please_select_group_to_forward: "Por favor, selecione grupo para encaminhar mensagem",
  // Company translations
  record_not_found: "Registro não encontrado!",
  please_select_position: "Por favor, selecione posição",
  delete_article_confirm: "Tem certeza de que deseja excluir este artigo?",
  delete_company_service_confirm: "Tem certeza de que deseja excluir o serviço da empresa?",
  block_translation_confirm: "Você realmente deseja bloquear a tradução automática em projetos para todos os membros da empresa",
  unblock_translation_confirm: "Você realmente deseja desbloquear a tradução automática em projetos para todos os membros da empresa",
  please_select_file: "Por favor, selecione um arquivo para enviar",
  role_in_building_industry: "Papel na indústria da construção*",
  invalid_email_address: "Endereço de e-mail inválido",
  please_enter_password: "Por favor, digite a senha",
  password_change_email_sent: "Um e-mail foi enviado para o seu e-mail Kjuup. Confirme sua nova senha clicando no link de confirmação no e-mail.",
  please_enter_username: "Por favor, digite o nome de usuário",
  username_same_as_before: "O nome de usuário não pode ser o mesmo de antes",
  profile_deleted_successfully: "Perfil excluído com sucesso",
  hardware_requirements: "Requisitos de hardware",
  hardware_requirements_list: "• 4GB RAM<br/>• Velocidade da CPU mín. 2GHz<br/>• Windows 7 ou superior / todas as versões do macOS",
  submitting: "Enviando...",
  signing_in: "Entrando...",
  please_enter_service_name: "Por favor, digite o nome do serviço",
  something_went_wrong_error: "Aaaah! Algo deu errado...",
  something_went_wrong_try_again: "Desculpe, algo deu errado. Tente novamente",
  position_label: "Posição:",
  loading_room: "Carregando projeto...",
  navigating_to_room: "Navegando para o projeto",
  loading_chat: "Carregando chat...",
  translate: "Traduzir",
  show_original: "Mostrar original",
  saving: "Salvando...",
  language_selection_info: "A seleção de idioma é usada para todas as confirmações por e-mail relacionadas à empresa.",
  // Navigation bar labels
  nav_call: "Chamar",
  nav_home: "Início",
  nav_messages: "Mensagens",
  nav_todo: "Tarefas",
  nav_rooms: "Projetos",
  nav_all_rooms: "Todos os projetos",
  pinned_rooms_max: "Pode fixar até 10 projetos.",
  pinned_room_unpin: "Desafixar",
  pinned_rooms_drop: "Arraste o seu projeto para aqui para uma seleção rápida",
  nav_profile: "Perfil",
  nav_company: "Empresa",
  nav_company_documents: "Documentos",
  nav_logout: "Sair",
  // Create message dialog
  add_member_title: "Adicionar membro",
  continue_btn: "Continuar",
  search_placeholder: "Buscar",
  no_members_found: "Nenhum membro encontrado",
  no_groups_found: "Nenhum grupo encontrado",
  no_rooms_found: "Nenhum projeto encontrado",
  search_users_tab: "Utilizadores",
  search_documents_tab: "Documentos",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Nenhum arquivo",
  no_documents_available: "No documents",
  searching_users: "Procurando utilizadores...",
  no_users_found: "Nenhum utilizador encontrado",
  search_emails_tab: "E-mail",
  searching_emails: "Pesquisando e-mails...",
  no_emails_found: "Nenhum e-mail encontrado",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Grupo sem nome",
  unnamed_room: "Projeto sem nome",
  all_members: "Todos",
  room_label: "Projeto:",
  subject_label: "Assunto:",
  no_members: "Sem membros",
  // Loading states for room creation
  creating_structure: "Criando sua estrutura",
  opening_chat: "Abrindo o chat",
  please_wait: "Por favor, aguarde...",
  // ToDo page translations
  loading_todo: "Carregando ToDo...",
  task_updated: "Tarefa atualizada",
  error_updating_task: "Erro ao atualizar tarefa",
  task_deleted: "Tarefa excluída",
  error_deleting_task: "Erro ao excluir tarefa",
  delete_task_confirm: "Tem certeza de que deseja excluir esta tarefa?",
  description_label: "Descrição",
  description_placeholder: "Digite descrição...",
  date_time_label: "Data e hora",
  save_hint: "Ctrl+Enter para salvar, Esc para cancelar",
  edit_label: "Editar",
  delete_label: "Excluir",
  todo_list_title: "Tarefas",
  tasks_count: "tarefas",
  search_placeholder_todo: "Buscar...",
  select_task_to_open_chat: "Selecione uma tarefa para abrir o chat",
  today: "Hoje",
  yesterday: "Ontem",
  time_suffix: "", // Empty for Portuguese (24h format doesn't need suffix)
  from_chat: "Tarefa pendente de origem",
  assigned_to: "Atribuído a",
  assign_users: "Atribuir usuários",
  no_users_assigned: "Sem usuários atribuídos",
  assign: "Atribuir",
  assign_to: "Atribuir a...",
  navigate_to_chat: "Navegar para o chat",
  navigate_to_email: "Ir para o e-mail",
  show_original_message: "Mostrar origem",
  hide_original_message: "Ocultar origem",
  status_pending: "Pendente",
  status_in_progress: "Em progresso",
  status_completed: "Concluído",
  status_confirmed: "Confirmado",
  show: "Mostrar",
  close: "Fechar",
  log_todo_created: "ToDo criado",
  log_todo_confirmed: "ToDo confirmado",
  log_todo_deleted: "ToDo excluído",
  log_todo_updated: "ToDo atualizado",
  log_description_updated: "Descrição atualizada",
  log_deadline_updated: "Prazo atualizado",
  log_assigned_to: "Atribuído a {name}",
  log_unassigned_from: "Removido de {name}",
  log_assignment_added: "Atribuição adicionada: {name}",
  log_assignment_removed: "Atribuição removida: {name}",
  log_status_updated: "Status alterado de {from} para {to}",
  log_status_changed: "Status alterado",
  log_status_changed_to: "Status alterado para {status}",
  log_changed_status_to: "Status alterado para:",
  log_for_user: "para usuário:",
  log_user_updated_status: "Usuário atualizou o status do ToDo",
  log_changed_date_to: "Data alterada para:",
  log_changed_description_to: "Descrição alterada para:",
  log_moved_to: "Movido para {status}",
  todo_status_updated_from: "de",
  todo_status_updated_to: "para",
  filter_pending: "Pendente",
  filter_confirmed: "Confirmado",
  my_list: "Meu dia",
  todo_adjust_list: "Editar lista",
  apply: "Aplicar",
  filter_assigned_to_me: "Minhas tarefas",
  filter_assigned_by_me: "Delegado",
  todo_project_label: "Projeto:",
  assigned_users: "Usuários atribuídos:",
  todo_chat_label: "Chat:",
  history: "Histórico",
  todo_assigned_by: "Atribuído por:",
  todo_assigned_push: "ToDo atribuído:",
  todo_assigned_push_empty: "Um novo ToDo foi atribuído a você.",
  search_groups: "Grupos",
  search_chat_groups: "Grupos de chat",
  search_project_room: "Projeto",
  search_messages_tab: "Mensagens",
  searching_groups: "Procurando grupos...",
  searching_rooms: "Procurando projetos...",
  no_groups_found: "Nenhum grupo encontrado",
  no_rooms_found: "Nenhum projeto encontrado",
  // ToDo filter translations
  todo_filters: "Filtros",
  todo_filter_by_project: "Filtrar por projeto",
  todo_status: "Status",
  todo_assignment: "Atribuição",
  todo_filter_by_user: "Filtrar por pessoa atribuída",
  todo_active_filters: "Filtros ativos:",
  todo_progress: "Progresso",
  todo_my_list_empty: "Seu dia está vazio",
  todo_my_list_empty_hint: "Clique no botão acima para adicionar tarefas",
  create_poll: "Enquete",
  poll_question_label: "PERGUNTA",
  poll_question_placeholder: "Faça uma pergunta",
  poll_options_label: "OPÇÕES",
  poll_option: "Opção",
  poll_add_option: "Adicionar opção",
  poll_allow_multiple: "Permitir várias respostas",
  poll_multiple_allowed: "Selecione uma ou mais opções",
  poll_select_option: "Selecione uma opção",
  poll_view_votes: "Ver votos",
  poll_vote_singular: "voto",
  poll_vote_plural: "votos",
  poll_votes: "Votos da enquete",
  poll_no_votes_yet: "Ainda não há votos",
  transcript_step_processing: "Transcrição em andamento...",
  ai_transcript_tab: "AI-Transcrição",
  ai_transcript_info: "Disponível apenas para mensagens de voz criadas após 09.03.2026.",
  transcript_more: "...mais",
  transcript_less: "...menos",
  ki_transcript_voice_message: "KI-Transcrição da mensagem de voz",
  ki_image_analysis: "Análise de imagem assistida por IA",
  type_message: "Digite uma mensagem",
  email_tab_messages: "Mensagens",
  email_tab_email: "E-Mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Contas de e-mail",
  email_connect_gmail: "Conectar Gmail",
  email_connect_outlook: "Conectar Outlook",
  email_no_accounts: "Nenhuma conta de e-mail conectada",
  email_no_accounts_hint: "Conecte uma conta de e-mail nas configurações do seu perfil",
  email_no_messages: "Nenhum e-mail",
  email_from: "De",
  email_to: "Para",
  email_subject: "Assunto",
  email_disconnect: "Desconectar",
  email_disconnect_confirm: "Tem certeza de que deseja desconectar esta conta de e-mail? Todos os e-mails sincronizados serão removidos.",
  email_account_disconnected: "Conta de e-mail desconectada com sucesso",
  email_account_disconnect_failed: "Falha ao desconectar a conta",
  email_connecting: "Conectando...",
  email_account_connected: "Conta conectada com sucesso",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Ir para configurações",
  email_date: "Data",
  email_reply: "Responder",
  email_forward: "Encaminhar",
  email_copy_text: "Copiar texto",
  email_text_copied: "Copiado!",
  email_text_copy_failed: "Não foi possível copiar o texto.",
  email_delete: "Excluir",
  email_not_spam: "Não é spam",
  email_not_spam_success: "E-mail movido para a caixa de entrada.",
  email_not_spam_failed: "Falha ao mover para a caixa de entrada.",
  email_delete_confirm: "Tem certeza de que deseja excluir este e-mail?",
  email_delete_from_folder: "Tem certeza de que deseja excluir de {folder}?",
  email_delete_permanent_from_folder:
    "Tem certeza de que deseja excluir permanentemente de {folder}? Esta ação não pode ser desfeita.",
  email_save_draft_confirm: "Deseja salvar este e-mail como rascunho?",
  email_save_draft: "Salvar rascunho",
  email_discard: "Descartar",
  email_back_to_compose: "Voltar à composição",
  email_draft_saved: "Rascunho salvo.",
  email_draft_save_failed: "Falha ao salvar o rascunho.",
  email_loading: "Carregando e-mails...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Selecionar",
  email_attachment_singular: "Anexo",
  email_attachment_plural: "Anexos",
  email_back: "Voltar",
  email_download: "Baixar",
  email_close: "Fechar",
  email_preview: "Pré-visualizar",
  email_preview_not_available: "Pré-visualização não disponível",
  email_preview_failed: "Pré-visualização não disponível",
  select_attachments: "Selecionar anexos",
  email_loading_preview: "A carregar pré-visualização...",
  email_mark_unread_failed: "e-mail(s) não puderam ser marcados como não lidos.",
  email_delete_failed: "e-mail(s) não puderam ser eliminados.",
  filter_all: "Todos",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Mensagens diretas",
  my_notes: "My Space",
  filter_internal_groups: "Chats de grupo internos",
  filter_external_groups: "Chats de grupo externos",
  filter_group_chats: "Chats de grupo",
  filter_groups_internal: "Internos",
  filter_groups_external: "Externos",
  filter_unread_only: "Apenas não lidos",
  room_daily_briefing_info: "Quando ativado, um relatório deste projeto é gerado a cada 24 horas no horário definido nas configurações pessoais — mas apenas se houver atividade nesse período.",
  email_select_all: "Selecionar tudo",
  email_deselect_all: "Desmarcar tudo",
  email_reply_all: "Responder a todos",
  email_reply_placeholder: "Digite sua resposta...",
  email_forward_placeholder: "Adicione uma mensagem...",
  email_edit_draft: "Editar rascunho",
  email_attach: "Anexar",
  email_attachment_from_original: "Da mensagem original",
  email_remove: "Remover",
  email_drop_files: "Solte os arquivos para anexar",
  email_loading_attachments: "Carregando anexos...",
  email_archive: "Arquivar",
  mark_unread: "Marcar como não lido",
  mark_read: "Marcar como lido",
  email_all_accounts: "Todas as contas",
  email_error: "Erro",
  email_delete_email_failed: "Falha ao excluir o e-mail.",
  enter_url: "Insira a URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Subscrever agora',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MÊS DE TESTE GRÁTIS',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Sem pagamento hoje. Não são solicitados dados de cartão de crédito antes de a assinatura paga começar.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Gerencie todas as contas de e-mail diretamente no Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'A IA escreve as respostas – você só confirma',
  kjuup_io_feature_tasks: 'Tarefas e calendário sempre atualizados automaticamente',
  kjuup_io_choose_plan: 'Escolha o plano',
  kjuup_io_plan_monthly: 'Mensal',
  kjuup_io_plan_yearly: 'Anual',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Protegido pela Stripe · cancele a qualquer momento',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Pagamento recebido. A ativar a sua subscrição…',
  kjuup_io_toast_activating_soon: 'Pagamento recebido. A sua subscrição será ativada em breve.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Faltam {count} horas',
  kjuup_io_trial_left_hour: 'Falta 1 hora',
  kjuup_io_trial_left_minutes: 'Faltam {count} minutos',
  kjuup_io_trial_left_minute: 'Falta 1 minuto',
  kjuup_io_trial_left_seconds: 'Faltam {count} segundos',
  kjuup_io_trial_left_second: 'Falta 1 segundo',
  kjuup_io_trial_ending_now: 'Seu teste está terminando…',
  kjuup_io_request_timeout: 'A ligação expirou. Tente novamente.',
  kjuup_io_info_days_free: '{days} dias totalmente grátis – sua assinatura só começa após o período de teste.',
  kjuup_io_discount_total: 'Seu desconto: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Pessoal: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Fechar',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Seu teste gratuito terminou',
  kjuup_io_trial_ended_body: 'Assine o Kjuup.io para continuar usando o e-mail e outros recursos premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Seu teste gratuito começou',
  kjuup_io_toast_trial_fail: 'Não foi possível iniciar o teste gratuito',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / mês',
  kjuup_io_save_amount_year: 'Economize {price} por ano',
  kjuup_io_billed_annually_amount: '{price} cobrados anualmente',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'O que você recebe:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Nenhum cartão de crédito necessário – comece imediatamente, sem dados de pagamento.',
  kjuup_io_info_cancel_anytime: 'Cancele a qualquer momento – sem compromisso, sem risco.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Período de cobrança',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Forma de pagamento salva. A cobrança será feita ao fim do teste.',
  calendar_sync_info: 'Sincronize automaticamente todos os ToDos do Kjuup com o seu calendário.',
  calendar_no_accounts: 'Nenhum calendário conectado.',
  article_new_badge: 'NOVO',
  article_new_posts: '{0} novas publicações',
  documents: 'Documentos',
  add_documents: 'Adicionar documentos',
  no_preview_available: 'Pré-visualização indisponível',
  no_preview_hint: 'Este tipo de arquivo não pode ser pré-visualizado, mas será enviado mesmo assim.',
  max_documents_reached: 'Você pode anexar até 10 documentos por vez.',
  open_file: 'Abrir arquivo',
  twofa_title: 'Autenticação de dois fatores',
  twofa_method_totp: 'App de autenticação',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Introduz o código de 6 dígitos da tua app de autenticação.',
  twofa_enter_sms: 'Introduz o código de 6 dígitos que enviámos por SMS.',
  twofa_enter_email: 'Introduz o código de 6 dígitos que enviámos para o teu e-mail.',
  twofa_resend: 'Reenviar código',
  twofa_try_another: 'Tentar outro método',
  twofa_remember_device: 'Não voltar a perguntar neste dispositivo durante 30 dias',
  twofa_sent: 'Enviámos um código.',
  twofa_invalid_code: 'Esse código está incorreto. Tenta novamente.',
  twofa_something_wrong: 'Algo correu mal. Tenta novamente.',
  twofa_method_unavailable: 'Esse método não está disponível.',
  twofa_on_desc: 'A autenticação de dois fatores está ativa. Precisas de um código em cada início de sessão.',
  twofa_off_desc: 'Adiciona um segundo passo depois da palavra-passe. As apps de autenticação são a opção mais segura.',
  twofa_methods: 'Métodos',
  twofa_on: 'Ativa',
  twofa_add: 'Adicionar',
  twofa_default_method: 'Método predefinido',
  twofa_default: 'Predefinido',
  twofa_turn_off: 'Desativar',
  twofa_disable_hint: 'Introduz a palavra-passe e um código atual para desativar a autenticação de dois fatores.',
  twofa_disable_need: 'Introduz a palavra-passe e um código de verificação.',
  twofa_code_placeholder: 'Código de 6 dígitos ou de reserva',
  twofa_send_code: 'Enviar um código',
  twofa_primary_updated: 'O método predefinido foi atualizado.',
  twofa_disabled: 'A autenticação de dois fatores está desativada.',
  twofa_enabled: 'A autenticação de dois fatores está ativa.',
  twofa_totp_help: 'Digitaliza este código QR com o Google Authenticator, Authy ou 1Password. Também podes introduzir a chave manualmente.',
  twofa_secret_copied: 'Chave copiada',
  twofa_sms_help: 'Introduz o número no formato internacional. Enviaremos um código de 6 dígitos por SMS.',
  twofa_email_help: 'Enviaremos um código de 6 dígitos para o e-mail da tua conta.',
  twofa_backup_title: 'Códigos de reserva',
  twofa_backup_help: 'Guarda estes códigos de uso único num sítio seguro. Cada um serve uma vez se perderes o telemóvel.',
  twofa_copy_codes: 'Copiar códigos',
  twofa_codes_copied: 'Códigos de reserva copiados',
  twofa_regenerate: 'Obter novos códigos de segurança',
  twofa_regenerate_hint: 'Isto substitui os códigos de segurança não usados. Introduz a palavra-passe e um código atual.',
  twofa_backup_remaining: '{n} códigos de segurança não usados restantes',
  twofa_new_codes: 'Novos códigos de segurança',
  twofa_sms_unavailable: 'Os códigos por SMS ainda não estão disponíveis.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "As tarefas Kjuup que te foram atribuídas são copiadas para um projeto «Kjuup» no teu Todoist. As alterações no Todoist não são copiadas de volta.",
  todoist_connect: "Ligar Todoist",
  todoist_connected: "Todoist ligado",
  todoist_connect_failed: "Falha ao ligar o Todoist",
  todoist_disconnect: "Desligar",
  todoist_disconnected: "Todoist desligado",
  todoist_disconnect_confirm: "Desligar o Todoist? As tarefas que já estão no Todoist permanecem. A sincronização para.",
  todoist_sync_now: "Sincronizar agora",
  todoist_syncing: "A sincronizar…",
  todoist_sync_done: "Sincronização concluída",
  todoist_sync_failed: "Falha na sincronização",
  todoist_auth_error: "Volta a ligar o Todoist para continuar a sincronizar.",
  todoist_last_sync: "Última sincronização",
  todoist_not_connected: "O Todoist não está ligado",
  todoist_auth_url_failed: "Não foi possível abrir a página de autorização do Todoist.",
  recommend_text: "Entre no Kjuup para ficar conectado e manter sua comunicação organizada. Reúna seus canais, mantenha as mensagens nos projetos certos e comece cada manhã com um resumo e suas tarefas – tudo sincronizado com os apps que você já usa. Comece grátis:",
  pro_auth_signin_title: 'Bem-vindo de volta',
  pro_auth_signin_sub: 'Entre com seu e-mail de trabalho.',
  pro_auth_email_or_username: 'E-mail ou nome de usuário',
  pro_auth_email_placeholder: 'nome@empresa.de',
  pro_auth_forgot_password: 'Esqueceu a senha?',
  pro_auth_create_account: 'Criar conta',
  pro_auth_show_password: 'Mostrar senha',
  pro_auth_hide_password: 'Ocultar senha',
  pro_auth_register_sub: 'Enviaremos um link para confirmar seu e-mail.',
  pro_auth_register_plus_sub: 'Escolha um nome de usuário e uma senha. Em seguida, você define seu PIN de segurança.',
  pro_auth_check_credentials: 'Verifique seu e-mail e senha',
  pro_news_export_pdf: 'Exportar como PDF',
  pro_news_pdf_failed: 'Não foi possível criar o PDF.',
  pro_news_pdf_attachments: 'Anexos',
  pro_news_pdf_video: 'Vídeo',
  pro_auth_forgot_sub: 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
  pro_auth_send_link: 'Enviar link de redefinição',
  pro_auth_plus_reset: 'Redefinir com PIN',
  pro_auth_show_pin: 'Mostrar PIN',
  pro_auth_hide_pin: 'Ocultar PIN',
  v2_auth_plus_only: 'Apenas Kjuup+',
  room_action_media: "Arquivos",
  room_tab_overview: "Visão geral",
  room_tab_history: "Histórico",
  chat_info_media: "Arquivos",
  messages: "mensagens",
  pro_todo_project_required: "Escolha um projeto",
  pro_todo_choose_project: "Para qual projeto é esta tarefa?",
  cockpit_report_delete_confirm: "Excluir este relatório diário?",
  cockpit_report_deleted: "Relatório diário excluído",
  cockpit_tab_company: "Empresa",
  cockpit_bookmarked_priorities: "Tarefas salvas",
  cockpit_load_error: "Não foi possível carregar o cockpit.",
  cockpit_retry: "Tentar novamente",
  cockpit_yesterday: "Ontem",
  cockpit_greeting_morning: "Bom dia",
  cockpit_greeting_day: "Boa tarde",
  cockpit_greeting_evening: "Boa noite",
  cockpit_assistant_q_open: "O que está em aberto hoje?",
  cockpit_assistant_q_summarize: "Resuma o chat {{room}}",
  cockpit_assistant_q_overdue: "Quais tarefas estão atrasadas?",
  cockpit_assistant_new: "{{n}} novos",
  cockpit_assistant_important: "{{n}} importantes",
  cockpit_assistant_title: "Assistente Kjuup",
  cockpit_assistant_hint: "Toque e pergunte",
  room_overview_priority_no_detail: "O relatório não traz mais detalhes sobre esta prioridade.",
  room_overview_priority_from: "Fonte: {{name}}",
  room_overview_priority_open_task: "Abrir tarefa",
  cockpit_priority_position: "{{index}} de {{total}} prioridades",
  room_overview_today_title: "Importante hoje",
  room_overview_all_tasks: "Todas",
  room_overview_tasks_empty: "Sem prazos ou tarefas em aberto",
  room_overview_appointments_empty: "Sem compromissos próximos",
  room_overview_no_priorities: "Nenhuma prioridade em aberto no último relatório.",
  cockpit_report_top5: "As 5 principais prioridades",
  cockpit_report_todo_created: "Tarefa criada",
  cockpit_report_source_missing: "Não foi possível encontrar a mensagem de origem.",
  delete_bookmarked_priority_confirm: "Tem certeza de que deseja excluir esta tarefa salva?",
  cockpit_report_create_todo: "Criar tarefa",
  cockpit_priorities_deleting: "Excluindo …",
  cockpit_priorities_select: "Excluir várias",
  cockpit_report_none: "Nenhuma entrada.",
  cockpit_priorities_delete_confirm: "Tem certeza de que deseja excluir {count} tarefas salvas?",
  cockpit_priorities_delete_failed: "Não foi possível excluir {count} tarefas",
  cockpit_priorities_deleted: "{count} tarefas excluídas",
  cockpit_priorities_selected: "{count} selecionadas",
  cockpit_channel_connected: "Conectado",
  cockpit_channel_not_connected: "Não conectado",
  cockpit_channel_connect: "Conectar",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Ativo",
  cockpit_channel_hidden: "Oculto",
  cockpit_channel_enable: "Ativar",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Verificar conexão",
  cockpit_channel_fix: "Verificar",
  cockpit_channel_forward: "Endereço de encaminhamento",
  cockpit_channel_not_set_up: "Não configurado",
  cockpit_channel_set_up: "Configurar",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Conexão perdida",
  cockpit_channel_importing: "Importando",
  cockpit_channel_removing: "Desconectando",
  cockpit_channel_reconnect: "Reconectar",
  cockpit_channels_title: "Canais",
  cockpit_company_role_super_admin: "Admin da empresa",
  cockpit_company_role_dept_admin: "Admin de departamento",
  cockpit_company_role_member: "Colaborador",
  cockpit_company_none: "Nenhuma empresa Kjuup+ encontrada",
  cockpit_company_eyebrow: "Empresa",
  cockpit_company_inactive: "inativa",
  cockpit_company_settings: "Configurações da empresa",
  cockpit_company_employees: "Colaboradores",
  cockpit_company_internal_rooms: "Projetos internos",
  cockpit_report_all_projects: "Todos os projetos",
  cockpit_report_progress_emails: "Analisando e-mails",
  cockpit_report_progress_chats: "Analisando mensagens de chat",
  cockpit_report_progress_documents: "Analisando anexos e documentos",
  cockpit_report_progress_tasks: "Analisando tarefas",
  cockpit_report_progress_summarizing: "Analisando conteúdo",
  cockpit_report_progress_reading: "Reutilizando conteúdo já analisado",
  cockpit_report_progress_collecting: "Coletando e-mails, chats e tarefas dos seus projetos",
  cockpit_report_progress_priorities: "Reunindo prioridades, prazos e decisões",
  cockpit_report_progress_queued: "Preparando o relatório",
  cockpit_report_creating_title: "Seu relatório diário está sendo preparado",
  cockpit_report_progress_count_one: "1 item analisado",
  cockpit_report_progress_count_many: "{{count}} itens analisados",
  cockpit_report_progress_hint: "Isso geralmente leva de um a dois minutos – você pode continuar usando o cockpit enquanto isso.",
  cockpit_report_time_hint: "O relatório diário é criado todos os dias às {{hour}}:00 para os cinco projetos mais ativos.",
  room_overview_priorities_title: "Status atual e prioridades",
  room_overview_as_of: "Atualizado em {{time}}",
  cockpit_report_delete: "Excluir relatório diário",
  email_tag_daily_briefing: "Relatório diário",
  cockpit_report_unread: "Novo",
  cockpit_report_clear_project: "Mostrar todos os projetos",
  cockpit_filter_project: "Projeto",
  cockpit_filter_all_projects: "Todos os projetos",
  cockpit_report_recreate: "Recriar relatório diário",
  cockpit_report_hide_previous: "Ocultar relatórios diários anteriores",
  cockpit_report_show_previous: "Mostrar relatórios diários anteriores",
  cockpit_report_room_empty: "Ainda não há relatório diário para este projeto",
  cockpit_report_empty: "Ainda não há relatório diário",
  cockpit_report_room_empty_hint: "Crie um relatório diário apenas para este projeto.",
  cockpit_report_needs_mailbox: "Conecte uma conta de e-mail para que o Kjuup possa criar um relatório diário com tarefas automáticas.",
  cockpit_report_create: "Criar relatório diário",
  cockpit_email_connect: "Conectar e-mail",
  cockpit_email_none_title: "Nenhuma conta de e-mail conectada ainda",
  cockpit_email_none_reports: "Conecte sua caixa de e-mail para que o Kjuup possa atribuir os e-mails recebidos aos seus projetos e criar relatórios diários com tarefas.",
  cockpit_email_none_client: "Conecte Gmail, Outlook ou IMAP para ler, atribuir e responder e-mails diretamente no Kjuup.io.",
  cockpit_email_reports_title: "Cliente de e-mail atual",
  cockpit_email_reports_text: "Sem caixa de entrada no Kjuup.io · {{rooms}} projetos com relatório diário às {{hour}}:00 · os e-mails recebidos são atribuídos aos seus projetos.",
  cockpit_email_reports_rooms: "Gerenciar projetos",
  cockpit_email_settings: "Configurações de e-mail",
  cockpit_email_error_title: "Verificar conexão",
  cockpit_email_client_title: "Caixa de entrada conectada",
  cockpit_email_accounts_n: "{{n}} conta conectada",
  cockpit_email_last_sync: "última sincronização {{when}}",
  cockpit_email_report_at: "Relatório diário às {{hour}}:00",
  cockpit_email_open_inbox: "Abrir caixa de entrada",
  cockpit_email_eyebrow: "Kjuup-E-mail",
  cockpit_email_accounts_label: "Endereços de e-mail conectados",
  email_folder_sent: "Itens enviados",
  email_no_subject: "(Sem assunto)",
  cockpit_email_detail_loading: "Carregando e-mail …",
  cockpit_email_detail_failed: "Não foi possível carregar o e-mail.",
  cockpit_email_detail_empty: "Este e-mail não tem texto.",
  cockpit_personal_settings: "Configurações pessoais",
  cockpit_companies: "Empresas",
  cockpit_title: "Cockpit",
  cockpit_back: "Voltar à visão geral",
  cockpit_day_overview: "Seu dia em resumo",
  email_saved_to_project: "E-mail salvo no projeto",
  email_classify_need_project: "Informe um nome de projeto",
  cockpit_email_deleted: "E-mail excluído",
  cockpit_email_sent_empty: "Nenhum e-mail enviado ainda.",
  cockpit_email_incoming_empty: "Nenhum e-mail recebido ainda.",
  cockpit_email_incoming_title: "E-mails",
  cockpit_email_incoming_sub: "Atribua os e-mails recebidos e enviados aos seus projetos. Aqui você pode ajustar a atribuição.",
  cockpit_email_incoming_unassigned_n: "{{n}} não atribuídos",
  cockpit_email_folder_inbox: "Caixa de entrada",
  cockpit_email_folder_sent: "Enviados",
  cockpit_email_open: "Abrir e-mail",
  cockpit_email_incoming_suggested: "Sugerido: {{room}}",
  cockpit_email_incoming_apply: "Aplicar",
  cockpit_email_incoming_adjust: "Ajustar atribuição",
  cockpit_email_incoming_saving: "Salvando …",
  cockpit_email_incoming_unassigned: "Não atribuído",
  cockpit_email_incoming_show_less: "Mostrar menos",
  cockpit_email_incoming_show_all: "Mostrar todos ({{n}})",
  cockpit_io_settings: "Configurações do Kjuup.io",
  cockpit_io_settings_sub: "Plano e licenças, atribuição de colaboradores, cobrança e faturas.",
  products_coming_soon: "Em breve",
  cockpit_upsell_io_title: "Seu escritório que pensa junto",
  cockpit_upsell_io_text: "Conecte suas contas de e-mail ao Kjuup. E-mails, anexos e mensagens são salvos automaticamente no projeto correspondente e, opcionalmente, podem ser armazenados no seu servidor. Todos os dias você recebe um resumo de todos os projetos com os pontos principais de todo o conteúdo, e suas tarefas são sincronizadas com seu calendário ou aplicativo de tarefas.",
  cockpit_upsell_io_soon_title: "Ainda não disponível para contratação",
  cockpit_upsell_io_soon_text: "O Kjuup.io será lançado em breve. Solicite informações agora – avisaremos assim que você puder contratar o Kjuup.io.",
  cockpit_upsell_io_planned_price: "Preço previsto",
  cockpit_upsell_io_cta_request: "Solicitar informações",
  kjuup_plus_abo_per_year: "/ ano",
  kjuup_plus_abo_per_month: "/ mês",
  kjuup_plus_abo_status_active: "Ativo",
  kjuup_plus_abo_status_requested: "Cancelamento solicitado",
  kjuup_plus_abo_status_past_due: "Pagamento pendente",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Assinatura",
  kjuup_plus_abo_title: "Pacote Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 licença disponível",
  kjuup_plus_abo_billing: "Cobrança",
  kjuup_plus_abo_yearly: "Anual",
  kjuup_plus_abo_monthly: "Mensal",
  kjuup_plus_abo_amount: "Valor",
  kjuup_plus_abo_ends: "Termina em",
  kjuup_plus_abo_renews: "Próxima renovação",
  kjuup_plus_abo_next_invoice: "Próxima fatura",
  kjuup_plus_abo_intro: "Preço de lançamento",
  kjuup_plus_abo_pending_tier: "A partir da próxima renovação",
  kjuup_plus_abo_manual: "O Kjuup+ está ativo para sua empresa por meio de um acordo individual.",
  kjuup_plus_abo_invoices: "Faturas",
  kjuup_plus_abo_invoice_paid: "Paga",
  kjuup_plus_abo_invoice_view: "Ver",
  kjuup_plus_abo_invoices_less: "Mostrar menos",
  kjuup_plus_abo_member_hint: "A cobrança e o cancelamento são gerenciados pelos administradores da sua empresa.",
  kjuup_plus_abo_withdraw: "Retirar solicitação",
  kjuup_plus_abo_cancel_note: "Motivo (opcional)",
  kjuup_plus_abo_cancel_send: "Solicitar cancelamento",
  kjuup_plus_abo_cancel: "Cancelar assinatura",
  cockpit_upsell_plus_f1: "Gerencie a atividade de comunicação de todos os seus colaboradores",
  cockpit_upsell_plus_f2: "Informe grupos de usuários específicos dentro da empresa",
  cockpit_upsell_plus_f3: "Salve os chats de grupo internos",
  cockpit_upsell_plus_when_yearly: "com pagamento anual",
  cockpit_upsell_plus_size_small: "1–50 colaboradores",
  cockpit_upsell_plus_size_large: "51–200 colaboradores",
  cockpit_upsell_plus_title: "Kjuup+ para empresas",
  cockpit_upsell_plus_text: "Gerencie colaboradores, permissões de escrita e a comunicação da empresa em um só lugar. Os canais internos ficam com sua equipe, os canais externos conectam você a parceiros de projeto, e você pode alcançar diretamente grupos específicos. Além do Kjuup+, você pode contratar o acesso ao Kjuup.io para grupos de colaboradores. Kjuup+ e Kjuup.io podem ser combinados.",
  cockpit_upsell_plus_size: "Tamanho da empresa",
  cockpit_upsell_plus_billing: "Cobrança",
  cockpit_upsell_plus_per_company: "/ empresa · mês sem impostos",
  cockpit_upsell_plus_onboarding: "Os custos de integração/implantação dependem do tamanho da empresa",
  cockpit_upsell_plus_larger: "Preços para empresas maiores sob consulta",
  cockpit_upsell_plus_cta: "Consulta sem compromisso",
  cockpit_kpi_deadlines_tasks: "Prazos e tarefas",
  cockpit_kpi_appointments: "Compromissos",
  cockpit_room_admin: "Gerenciamento de projetos e chats",
  cockpit_room_admin_sub: "Todos os projetos da empresa com membros, mídia e chats.",
  pro_todo_not_found: "Esta tarefa não está mais disponível.",
  cockpit_chip_overdue: "Atrasada",
  cockpit_chip_today: "Hoje",
  cockpit_calendar_week: "Sem. {{week}}",
  cockpit_prev_week: "Semana anterior",
  cockpit_next_week: "Próxima semana",
  cockpit_chip_requested: "Solicitada",
  cockpit_todo_due: "Prazo {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "de {{name}}",
  cockpit_todo_since: "desde {{when}}",
  cockpit_todo_no_date: "Sem data",
  cockpit_todo_mark_done: "Marcar como concluída",
  cockpit_my_tasks_title: "Minhas tarefas",
  cockpit_today_tasks_group: "Tarefas de hoje",
  cockpit_assign_none: "Ninguém atribuído",
  no_project_found: "Nenhum projeto encontrado",
  cockpit_row_more_actions: "Mais ações",
  needs_date: "Definir data",
  cockpit_assign_proposal: "{{name}} reconhecido – atribuir?",
  cockpit_assign_proposal_confirm: "Atribuir",
  cockpit_assign_proposal_dismiss: "Ignorar",
  cockpit_priority_date: "Data",
  todo_calendar_add: "Adicionar ao calendário",
  todo_calendar_remove: "Remover do calendário",
  cockpit_todo_change_project: "Alterar projeto",
  cockpit_todo_set_date: "Definir data",
  pro_todo_done_confirm: "Tem certeza de que deseja marcar esta tarefa como concluída?",
  cockpit_task_delete_failed: "Não foi possível excluir a tarefa.",
  cockpit_setup_title: "Concluir a configuração",
  cockpit_setup_text: "Decida se quer usar chats e se o Kjuup.io deve funcionar como cliente de e-mail ou apenas com projetos e relatórios diários.",
  cockpit_setup_cta: "Configurar agora",
  cockpit_group_tasks: "Prazos e tarefas",
  cockpit_group_appointments: "Compromissos",
  cockpit_report_no_activity: "Este projeto não teve novas mensagens ou e-mails nas últimas 24 horas.",
  cockpit_report_room_unavailable: "Este projeto não está disponível.",
  cockpit_report_create_failed: "Não foi possível criar o relatório diário.",
  cockpit_report_created: "Relatório diário criado",
  addon_enable_confirm: "Ativar o complemento?",
  addon_enable: "Ativar",
  addon_enabled: "Complemento ativado",
  nav_email: "E-mail",
  nav_my_cockpit: "Meu cockpit",
  nav_news: "Novidades",
  nav_recommend: "Recomendar",
  pro_todo_status_done: "Concluída",
  pro_todo_status_open: "Aberta",
  v2_todo_remove: "Remover",
  pro_todo_search_people: "Buscar pessoas",
  pro_todo_clear: "Limpar",
  pro_todo_assigned: "(atribuído)",
  pro_todo_no_people: "Nenhuma pessoa encontrada",
  pro_todo_search_rooms: "Buscar projetos",
  pro_todo_no_rooms_match: "Nenhum projeto corresponde a “{{q}}”",
  pro_todo_no_rooms: "Nenhum projeto encontrado",
  pro_todo_activity: "Atividade",
  pro_todo_show_less: "Mostrar menos",
  pro_todo_show_all: "Mostrar tudo ({{n}})",
  pro_todo_due: "Prazo",
  pro_todo_room: "Projeto",
  pro_todo_select_room: "Selecionar projeto",
  pro_todo_status: "Status",
  pro_todo_more: "Mais",
  pro_todo_edit_title: "Editar tarefa",
  pro_todo_description: "Descrição",
  pro_todo_created_by: "Criada por",
  pro_todo_chat: "Chat",
  navigate_to_source: "Ir para a origem",
  todo_calendar_connect_title: "Nenhum calendário conectado",
  todo_calendar_connect_body_web: "Conecte um calendário nas configurações de sincronização de calendário para adicionar tarefas a ele.",
  todo_calendar_connect: "Conectar",
  todo_calendar_removed: "Removido do seu calendário",
  todo_calendar_added_later: "Adicionado. Não foi possível acessar seu calendário; o Kjuup tentará novamente mais tarde.",
  todo_calendar_added: "Adicionado ao seu calendário",
  todo_calendar_no_date: "Somente uma tarefa com data pode ser adicionada a um calendário.",
  todo_calendar_failed: "Não foi possível atualizar seu calendário. Tente novamente.",
  todo_calendar_date_title: "Ainda sem data",
  todo_calendar_date_save: "Definir data e adicionar",
  todo_calendar_date_body_web: "Esta tarefa salva ainda não tem data. Defina uma para adicioná-la ao seu calendário.",
  kjuup_io_setup_saved: "Configuração salva",
  kjuup_io_setup_step: "Etapa",
  kjuup_io_setup_chats_title: "Deseja usar chats?",
  kjuup_io_setup_email_title: "Onde você quer ler seus e-mails?",
  kjuup_io_setup_chats_sub: "Os chats com colegas e parceiros de projeto são opcionais. Você pode mostrá-los ou ocultá-los no cockpit a qualquer momento.",
  kjuup_io_setup_email_sub: "Aqui você escolhe apenas se usa um cliente de e-mail no Kjuup ou continua com seu programa de e-mail atual, como o Outlook ou outro. Você pode mudar depois.",
  kjuup_io_setup_chats_yes: "Sim, mostrar chats",
  kjuup_io_setup_chats_yes_text: "Mensagens contém chats e e-mails. Os projetos têm chats em grupo para todos os envolvidos.",
  kjuup_io_setup_chats_no: "Não, trabalhar sem chats",
  kjuup_io_setup_chats_no_text: "Os chats ficam ocultos. “Mensagens” passa a “E-mail”; projetos, tarefas e relatórios diários permanecem.",
  kjuup_io_setup_email_client: "Cliente de e-mail no Kjuup",
  kjuup_io_setup_email_client_text: "Leia e responda e-mails diretamente no Kjuup.",
  kjuup_io_setup_email_reports: "Cliente de e-mail atual",
  kjuup_io_setup_email_reports_text: "Continue lendo e respondendo no seu programa atual, como o Outlook ou outro.",
  kjuup_io_setup_skip: "Mais tarde",
  next: "Avançar",
  kjuup_io_setup_finish: "Concluir a configuração",
  today_label: "hoje",
  tomorrow_label: "amanhã",
  cockpit_todo_overdue: "atrasada",
  cockpit_report_management_fazit: "Resumo gerencial",
  cockpit_todo_appointment: "Compromisso",
  cockpit_todo_deadline: "Prazo",
  cockpit_todo_deadline_define: "Definir prazo",
  pro_todo_status_acknowledged: "Confirmada",
  pro_todo_responsible: "Responsável",
  pro_todo_notice_confirmed: "Confirmado no chat",
  pro_todo_notice_sent_at: "Mensagem enviada",
  pro_todo_notice_again: "Enviar a mensagem novamente",
  pro_todo_notice_send: "Informar por mensagem do Kjuup",
  pro_todo_add_assignee: "Adicionar",
  pro_todo_edit: "Editar",
  pro_todo_change_room: "Alterar projeto",
  pro_todo_due_on: "Prazo em",
  pro_todo_edit_due: "Editar prazo",
  pro_todo_no_date: "Sem data",
  pro_todo_edit_description: "Editar descrição",
  pro_todo_no_description: "Ainda sem descrição",
  pro_todo_title_label: "Título",
  pro_todo_title_placeholder: "Introduza um título...",
  pro_todo_task: "Tarefa",
  pro_todo_what: "O que precisa de ser feito?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Fontes",
  previous: "Anterior",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (até {max} colaboradores)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (até {max} colaboradores)",
  kjuup_plus_abo_status_ends: "Termina em {date}",
  kjuup_plus_abo_seats_over: "Mais de {max} colaboradores – a Kjuup entrará em contato com uma oferta personalizada.",
  kjuup_plus_abo_seats_next: "Se mais colaboradores entrarem, o pacote muda automaticamente para {next} (cobrança proporcional).",
  kjuup_plus_abo_seats_used: "{used} de {total} licenças em uso",
  kjuup_plus_abo_seats_free: "Ainda {count} licenças disponíveis",
  kjuup_plus_abo_intro_until: "até {date}",
  kjuup_plus_abo_invoice_open: "Em aberto · vence em {date}",
  kjuup_plus_abo_invoices_all: "Mostrar todas ({count})",
  kjuup_plus_abo_requested_hint: "Cancelamento solicitado em {date}. A Kjuup o confirmará ao fim do período contratado ({end}).",
  kjuup_plus_abo_cancel_hint: "A Kjuup analisa sua solicitação e confirma o cancelamento ao fim do período contratado ({end}). Até lá, o Kjuup+ continua ativo.",
  kjuup_plus_abo_withdrawn: "Solicitação de cancelamento retirada",
  kjuup_plus_abo_requested: "Cancelamento solicitado",
  cockpit_upsell_plus_intro_hint: "primeiros {months} meses, depois {price}",
  cockpit_upsell_plus_badge: "PREÇO DE LANÇAMENTO DURANTE {months} MESES",
  calendar_syncing: "A atualizar a partir do calendário…",
  calendar_sync_up_to_date: "O calendário está em dia",
  calendar_sync_failed: "Falha na sincronização",
  delete_multiple_tasks_confirm: "Tem certeza de que deseja excluir {count} ToDos?",
  todos_deleted_count: "{count} ToDos excluídos",
  todos_deleted_partial: "{ok} ToDos excluídos, {fail} com falha",
  todo_unknown: "Desconhecido",
  todo_created_from_message: "Tarefa criada a partir desta mensagem",
  kjuup_io_todo_calendar_trial_ended_note: "Sincronização de calendário · Assinar",
  kjuup_io_todo_calendar_nudge: "Sincronizar esta ToDo com seu calendário?",
  kjuup_io_todo_calendar_nudge_cta: "Ativar Kjuup.io",
  todo_confirmed: "ToDo confirmado",
  pro_todo_bulk_delete_title: "Excluir {{n}} tarefas?",
  pro_todo_previous_none_own: "As tarefas atrasadas foram atribuídas a você por outras pessoas e só elas podem excluí-las.",
  pro_todo_previous_none: "Nenhuma tarefa atrasada",
  pro_todo_previous_title: "Excluir {{n}} tarefas atrasadas?",
  pro_todo_previous_text: "Todas as suas tarefas abertas de dias anteriores serão excluídas.",
  pro_todo_previous_skipped: "{{n}} atribuídas por outras pessoas permanecem.",
  unassign_task_confirm: "Deseja cancelar sua atribuição nesta tarefa?",
  unassign_label: "Cancelar",
  pro_todo_delete_title: "Excluir tarefa",
  pro_todo_today: "Hoje",
  pro_todo_yesterday: "Ontem",
  pro_todo_since_yesterday: "Desde ontem",
  pro_todo_mark_open: "Marcar como aberta",
  verify_completion: "Verificar",
  new_label: "Novo",
  bookmarked_no_mylist: "As tarefas marcadas não podem ser adicionadas à Minha lista",
  delete_only_own: "Você só pode excluir tarefas criadas por você",
  todo_clear_all: "Limpar tudo",
  pro_todo_of_completed: "{{done}} de {{total}} concluídas",
  pro_todo_pick_date: "Escolher uma data",
  pro_todo_show_day: "Mostrar dia",
  pro_todo_section_upcoming: "Próximas",
  pro_todo_section_done: "Concluídas",
  pro_todo_room_empty_today: "Nenhuma tarefa para hoje neste projeto",
  pro_todo_room_empty_day: "Nenhuma tarefa neste dia neste projeto",
  pro_todo_delete_previous: "Excluir todas",
  pro_todo_empty_title: "Nada por aqui",
  pro_todo_empty_hint: "Nenhuma tarefa corresponde a esta visualização.",
  pro_todo_selected: "{{n}} selecionadas",
  delete_selected_count: "Excluir ({count})",
  pro_todo_adjust_done: "Pronto",
  pro_todo_deleting: "Excluindo...",
  pro_todo_reopen: "Reabrir tarefa",
  pro_todo_step_done: "Concluída",
  move_back_in_progress: "Voltar para em andamento",
  pro_todo_mark_not_started: "Marcar como não iniciada",
  back_into_in_progress: "Voltar para em andamento",
  pro_todo_mark_in_progress: "Marcar como em andamento",
  unassign_todo: "Cancelar atribuição do ToDo",
  pro_todo_open_room: "Abrir projeto",
  pro_todo_new_task: "Nova tarefa",
  select_user_back_to_in_progress: "Selecione o utilizador que volta para em andamento",
  cockpit_email_accounts_n_many: "{{n}} contas conectadas",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Contactos Kjuup",
  combined_tab_teams: "Contactos Teams",
  combined_bridge_failed: "Não foi possível criar a cópia no Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Contactos Kjuup e Teams: é criado um novo grupo que também aparece no Microsoft Teams.",
  teams_new_chat_title: "Novo chat do Teams",
  teams_new_chat_topic: "Nome do grupo (opcional)",
  teams_new_chat_start: "Iniciar chat",
  teams_new_chat_creating: "A criar o chat…",
  teams_new_chat_forbidden: "O Microsoft Teams não permite este chat (p. ex. uma pessoa fora da sua organização ou uma política da sua equipa de TI).",
  teams_new_chat_too_many: "Demasiadas pessoas para um chat.",
  teams_new_chat_type_hint: "Escreva um nome para pesquisar na sua organização.",
  teams_new_chat_directory_forbidden: "A sua organização não permite a pesquisa no diretório. Só são mostradas pessoas dos seus chats do Teams.",
  teams_new_chat_account: "Conta",
};
